import useBem from '@indicia/use-bem';

import { StatisticsType } from '../../types';
import RealAge from '../realAge/RealAge';

import './Statistics.scss';

const Statistics = ({ age, realAge, sticky }: StatisticsType) => {
  const { bemClassName, bemClassNameWithBase } = useBem('statistics');
  return (
    <div className={bemClassNameWithBase(null, 'stick', sticky)}>
      <div className={bemClassName('content')}>
        <div className={bemClassName('real-age')}>
          <RealAge
            age={age}
            realAge={realAge}
          />
        </div>
      </div>
    </div>
  );
};

export default Statistics;
